<template>
    <div class="sa-free-page">
        <div class="sa-free-page-header">
            <b-card class="sa-card sa-card-border" header="Dettagli Stanza" header-tag="header" footer-tag="footer" title="">
                <template #header>
                    <div style="display: flex">
                        <span style="flex: 1">Dettagli Letto</span>
                        <!--   <b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickPianoEdit()">
                            <i class="bi bi-pencil"></i>
                        </b-button> -->
                    </div>
                </template>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Struttura</label>
                        <span class="sa-data">{{ jsonData.denominazioneStruttura }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Presidio</label>
                        <span class="sa-data">{{ jsonData.denominazionePresidio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Piano</label>
                        <span class="sa-data">{{ jsonData.nomePiano }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Stanza</label>
                        <span class="sa-data">{{ jsonData.nomeStanza }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Sesso</label>
                        <span class="sa-data">{{ jsonData.descrizioneSesso }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Letto</label>
                        <span class="sa-data">{{ jsonData.nome }}</span>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Tipo Letto</label>
                        <span class="sa-data">{{ jsonData.tipoLetto }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Stato</label>
                        <span class="sa-data">{{ jsonData.statoAttuale }}</span>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Numero Cartella</label>
                        <span class="sa-data">{{ jsonDataAccettazione.numero || "NON DISPONIBILE" }}</span>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note</label>
                        <span class="sa-data">{{ jsonData.note }}</span>
                    </b-col>
                </b-row>
            </b-card>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    components: {},
    data() {
        return {
            id: null,
            idAccettazione: null,
            pathResource: "/rsapostilettoletti",
            pathResourceAccettazione: "/accettazioni",
            jsonData: {
                denominazioneStruttura: null,
                denominazionePresidio: null,
                nomePiano: null,
                nomeStanza: null,
                descrizioneSesso: null,
                nome: null,
                tipoLetto: null,
                statoAttuale: null,
                note: null,
                idAccettazione: null,
            },
            jsonDataAccettazione: {
                numeroCartella: null,
            },
        };
    },
    watch: {},
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
    },
    methods: {
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
            me.$emit("beforeLoadData");
        },
        loadDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.jsonData = response.data.data;
            if (me.jsonData.idAccettazione) {
                // console.log("Sono entrato perchè ho idAccettazione", me.jsonData.idAccettazione);
                me.loadDataAccettazione(me.jsonData.idAccettazione);
            }
            if (me.jsonData.statoAttuale === "DISPONIBILE" || me.jsonData.statoAttuale === "LIBERO" || me.jsonData.statoAttuale === "OCCUPATO") {
                let nascondiCampo = true;
                me.$emit("nascondiCampo", nascondiCampo);
            }
            me.$emit("setLinkBack", me.jsonData.idStanza);
        },
        loadDataError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei dati", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.$emit("afterLoadData");
        },

        loadDataAccettazione(idAccettazione) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceAccettazione + "/" + idAccettazione, null, me.loadDataAccettazioneSuccess, me.loadDataAccettazioneError);
            // console.log("IDACCETTAZIONE", idAccettazione);
        },
        loadDataAccettazioneSuccess(response) {
            let me = this;
            me.jsonDataAccettazione = response.data.data;
        },
        loadDataAccettazioneError(response) {
            // console.log(response);
            console.error("ERROR RISPOSTA DEL LOAD DATA", response);
        },
    },
};
</script>

<style></style>
